import React from 'react';

import { Stack, Text, Icon, HStack, StackProps } from '@chakra-ui/react';
import { useLocation } from '@reach/router';
import { FaDesktop } from '@react-icons/all-files/fa/FaDesktop';
import { FaEnvelope } from '@react-icons/all-files/fa/FaEnvelope';
import { FaPhone } from '@react-icons/all-files/fa/FaPhone';
import { Link as GatsbyLink } from 'gatsby';

import { useSiteMetadata } from '../../hooks/use-site-metadata';
import { SUBJECT_QUERY_PARAM } from '../../misc/contact';
import { Url } from '../../misc/enums';
import { formatPhoneNumber } from '../../misc/utilities';

function prettifySlug(slug: string) {
	return slug.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}

function getSubjectFromPathname(pathname: string) {
	const slug = pathname.split('/').at(-2)!;
	return prettifySlug(slug);
}

interface ContactLinksProps extends StackProps {
	size?: 'lg' | 'md';
}

export const ContactLinks = ({ size = 'lg', ...rest }: ContactLinksProps) => {
	const {
		organization: {
			contactPoint: { telephone, email },
		},
	} = useSiteMetadata();
	const { pathname } = useLocation();

	const subject = getSubjectFromPathname(pathname);

	const iconSize = size === 'lg' ? 6 : 8;
	const textSize = size === 'lg' ? 'lg' : 'xl';

	return (
		<Stack
			direction={{ base: 'column', lg: 'row' }}
			spacing={rest.spacing ? rest.spacing : { base: 8, lg: 0 }}
			justify="space-around"
			align="center"
			color="primary.500"
			{...rest}
		>
			<HStack
				as="a"
				href={`mailto:${email}`}
				rel="nofollow"
				spacing={3}
				w={{ base: '280px', lg: 'initial' }}
			>
				<Icon as={FaEnvelope} boxSize={iconSize} />
				<Text display="inline" fontSize={textSize}>
					{email}
				</Text>
			</HStack>
			<HStack
				as="a"
				href={`tel:${formatPhoneNumber(telephone)}`}
				rel="nofollow"
				spacing={3}
				w={{ base: '280px', lg: 'initial' }}
			>
				<Icon as={FaPhone} boxSize={iconSize} />
				<Text display="inline" fontSize={textSize}>
					{telephone}
				</Text>
			</HStack>
			<HStack
				as={GatsbyLink}
				to={`/${Url.CONTACT}/?${SUBJECT_QUERY_PARAM}=${subject}`}
				spacing={3}
				w={{ base: '280px', lg: 'initial' }}
			>
				<Icon as={FaDesktop} boxSize={iconSize} />
				<Text display="inline" fontSize={textSize}>
					Kontaktformular
				</Text>
			</HStack>
		</Stack>
	);
};
